<template>
  <div class="status-wrapper">
    <div class="status-bar">
      <timeline-step
        v-if="productTypeId === ProductIds.REFI"
        status="active"
        :step="1"
        title="Application Under Review"
        :maximumStep="stepCount"
      >
        <template v-slot:caption>
          <UnderReviewText @todoListClicked="emit('todoListClicked')" />
        </template>
      </timeline-step>

      <timeline-step
        v-else
        status="active"
        :step="1"
        title="Application Under Review"
        :maximumStep="stepCount"
      >
        <template v-slot:caption>
          <timeline-step-description class="mobile" :step="1" status="active">
            <template v-slot:description>
              <UnderReviewText />
            </template>
          </timeline-step-description>
        </template>
      </timeline-step>

      <timeline-step
        v-for="step in steps"
        :key="step.id"
        :status="step.status"
        :step="step.step"
        :title="step.title"
        :maximumStep="timeline?.length"
        :configuration="step"
        @titleClicked="currentstep = $event"
        @todoListClicked="emit('todoListClicked')"
      >
        <template v-slot:caption v-if="useV2 && currentstep === step.step">
          <timeline-step-description
            class="mobile"
            :step="step.step"
            :status="selectedStep.status"
          />
        </template>
      </timeline-step>
    </div>

    <template v-if="useV2">
      <div class="divider"></div>
      <timeline-step-description :step="1" :status="TimelineMilestoneStatus.ACTIVE">
        <UnderReviewText />
      </timeline-step-description>
    </template>
  </div>
</template>
<script setup lang="ts">
import { computed, defineEmits } from "vue";
import TimelineStep from "@/components/timeline/TimelineStep.vue";
import TimelineStepDescription from "@/components/timeline/TimelineStepDescription.vue";
import { ProductIds } from "@/config/constants";
import useApplicationStatus from "@/composables/application-status/useApplicationStatus";
import { TimelineMilestone, TimelineMilestoneStatus } from "@/models/applicationStatus";
import UnderReviewText from "@/components/application-statuses/EvaluationQueue/UnderReviewText.vue";
import { useStore } from "vuex";

useStore();

const emit = defineEmits<{
  (e: "todoListClicked"): void;
}>();

const { productTypeId, useV2, timeline, currentstep, selectedStep, stepCount } =
  useApplicationStatus();

const steps = computed(() => timeline.value.filter((s: TimelineMilestone) => s.step > 1));
</script>
